module.exports = __webpack_public_path__ + "static/media/iconDownload.483f12e1.svg";